import { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import axios from 'axios';
import PrintIcon from "@mui/icons-material/Print";
import { AccessContext } from '../../constant/accessContext';
import { useContext } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import RemoveIcon from '@mui/icons-material/Remove';
import { ToastContainer, toast } from 'react-toastify';
import ModuleTools from '../modals/ModuleTools';
import Button from '@mui/material/Button';
import {
    Dialog,

    DialogTitle,
    DialogActions,
    DialogContent,


} from "@mui/material";

import {
    TextField,
    Container,
    Card,
    CardContent,
    Typography,
    Stack,
} from '@mui/material';
import {
    getOrderAllLakVal,
    getCncProgramList,
    getCncCompletedPrograms,
    axiosInstances
} from '../../constant/url';



import {
    GridToolbar,
    GridToolbarContainer,
    GridToolbarExport,
} from '@mui/x-data-grid';
import useAxiosInterceptor from '../Interceptors/axios';

export default function M1cncProgramMasterComplete() {
    const accessModuleList = useContext(AccessContext).accessModuleList;
    const [selectedOrderList, setSelectedOrderList] = useState([])
    const [orderList, setOrderList] = useState([]);
    const [flattenedRows, setFlattenedRows] = useState([]);
    useAxiosInterceptor(axiosInstances)
    const access = useContext(AccessContext).authID;
    const slotColumnCommonFields = {
        sortable: false,
        filterable: false,
        pinnable: false,
        hideable: false,
        cellClassName: (params) => {
            return `${params?.field}-${params.row?.primaryId % 2 === 0 ? 'even' : 'odd'
                }`;
        },
    };

    const handleOrderList = () => {
        var bodyFormData = new FormData();
        bodyFormData.append('authId', access);
        bodyFormData.append('pageType', 'endPlateBending');
        axiosInstances({
            method: 'post',
            url: getOrderAllLakVal,
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(function (response) {
                //handle success
                const res_data = response.data;
                if (res_data.status_code === 101) {
                    toast('Api Authentication failed. login again.');
                } else if (res_data.status_code === 200) {
                    const data = res_data.data_orders;
                    setSelectedOrderList(data)
                    const ret_data_cd = [
                        {
                            id: 1,
                            program: '',
                            complete: '',
                            cnc_row_delete: 1,
                            orders: [
                                {
                                    orderNo: '',
                                    customerName: '',
                                    size: '',
                                    model: '',
                                    quantity: 0,
                                    ok: 0,
                                    rejection: 0,
                                    reason: '',
                                },
                                //   {
                                //     orderNo: '240624',
                                //     customerName: 'Aries Appliances',
                                //     size: 'F',
                                //     model: 'EP',
                                //     quantity: 12,
                                //     ok:0,
                                //     rejection: 0,
                                //     reason: '',
                                //   },
                                //   {
                                //     orderNo: '240608',
                                //     customerName: 'Chennai Ref',
                                //     size: '8 x 8 x 3R - 2',
                                //     model: 'EP',
                                //     quantity: 4,
                                //     ok: 0,
                                //     rejection: 0,
                                //     reason: '',
                                //   },
                                //   {
                                //     orderNo: '240614',
                                //     customerName: 'Chennai Ref',
                                //     size: '8 x 8 x 3R - 2',
                                //     model: 'EP',
                                //     quantity: 4,
                                //     ok: 0,
                                //     rejection: 0,
                                //     reason: '',
                                //   },
                            ],
                        },
                        // {
                        //   id: 2,
                        //   program: 'CCAL 2mm Feb 2024',
                        //   complete: '3/7/2024 04:40pm',
                        //   cnc_row_delete: 2,

                        //   orders: [
                        //     {
                        //       orderNo: '240608',
                        //       customerName: 'Chennai Ref',
                        //       size: '8 x 8 x 3R - 2',
                        //       model: 'EP',
                        //       quantity: 4,
                        //       ok: 0,
                        //       rejection: 0,
                        //       reason: '',
                        //     },
                        //     {
                        //       orderNo: '240614',
                        //       customerName: 'Air Cool Centre & Co',
                        //       size: '32 x 4 x 4R - 1',
                        //       model: 'EP',
                        //       quantity: 2,
                        //       ok: 0,
                        //       rejection: 0,
                        //       reason: '',
                        //     },
                        //     {
                        //       orderNo: '240624',
                        //       customerName: 'Aries Appliances',
                        //       size: 'F',
                        //       model: 'EP',
                        //       quantity: 12,
                        //       ok: 0,
                        //       rejection: 0,
                        //       reason: '',
                        //     },
                        //     {
                        //       orderNo: '240626',
                        //       customerName: 'Aries Appliances',
                        //       size: '12 x 8 x 4R - 6',
                        //       model: 'EP',
                        //       quantity: 12,
                        //       ok: 0,
                        //       rejection: 0,
                        //       reason: '',
                        //     },
                        //   ],
                        // },
                    ];
                    setOrderList(ret_data_cd);
                    toast('Order Retrieved');
                } else {
                    console.log(res_data.status_msg);
                }
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    };

    useEffect(() => {
        handleProgramList(access);
    }, [])

    const handleProgramList = () => {
        var bodyFormData = new FormData();
        bodyFormData.append('authId', access);
        bodyFormData.append('pageType', 'endPlateBending');
        axios({
            method: 'post',
            url: getCncCompletedPrograms,
            data: bodyFormData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(function (response) {
                // Handle success
                const res_data = response.data;
                if (res_data.status_code === 101) {
                    toast('API Authentication failed. Please log in again.');
                } else if (res_data.status_code === 200) {
                    const data = res_data.data;
                    if (data.length !== 0) {
                        const originalData = data;
                        if (Array.isArray(originalData)) {
                            const transformedData = originalData.map(transformObject);
                            setOrderList(transformedData);
                        }
                        else {
                            const transformedData = transformObject(originalData);
                            setOrderList([transformedData]);
                        }
                        toast('Completed Records retrived successfully.');
                    } else {
                        setOrderList([]);
                    }
                } else {
                    console.log(res_data.status_msg);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };
    const transformObject = (obj) => {
        return {
            cnc_pgm_id: obj.cnc_pgm_id ? parseInt(obj.cnc_pgm_id) : 0,
            program: obj.program_name ? obj.program_name : '',
            createdDate: obj.creation_datetime ? obj.creation_datetime : '',
            material: obj.material ? obj.material : "",
            completedate: obj.completion_datetime,
            orders: obj.orders.map((item) => ({
                order_id: item.id ? item.id : 0,
                orderNo: item.order_no ? item.order_no : '',
                customerName: item.customer_name ? item.customer_name : '',
                size: item.size ? item.size : '',
                model: item.model ? item.model : '',
                quantity: item.quantity ? parseInt(item.quantity, 10) : 0,
                ok: item.ok_count ? parseInt(item.ok_count, 10) : 0,
                rejection: item.rejection_count ? parseInt(item.rejection_count, 10) : 0,
                reason: item.reason ? item.reason : '',
            })),
        };
    };

    useEffect(() => {
        const flattenedRowsfn = () => {
            return orderList.map((programData, index) => [
                ...programData.orders?.map((order, orderIndex) => ({
                    primaryId: programData.cnc_pgm_id,
                    id: `${programData.cnc_pgm_id}-${orderIndex}`,
                    program: programData.program,
                    createdDate: programData.createdDate,
                    material: programData.material || "",
                    completedate: programData.completedate,
                    cnc_row_delete: programData.is_completed,
                    orderNo: order.orderNo,
                    customerName: order.customerName,
                    size: order.size,
                    model: order.model,
                    quantity: order.quantity,
                    ok: order.ok,
                    rejection: order.rejection,
                    reason: order.reason,
                    isFirstRow: orderIndex === 0,
                })) || [],

            ]).flat(); // Use .flat() to flatten the array

        };
        setFlattenedRows(flattenedRowsfn());

    }, [orderList]);

    const refreshData = (request) => {
        if (request) {
            handleOrderList(access);
        }
    };

    const columns = [
        {
            field: 'program',
            headerName: 'Program',
            renderCell: function (params) {
                return (
                    <div className={params.formattedValue.length > 30 ? "Complete" : "Complete"}>
                        <div >
                            <p className="mb-2">
                                {`Program: ${params.row.program}`}
                            </p>
                            <p className="mb-2">
                                {`Material: ${params.row.material}`}
                            </p>

                        </div>
                    </div>
                );
            },




            // valueFormatter: (params) => {
            //     console.log(params)

            //     const combinedValue = params
            //     console.log(combinedValue)
            //     if (combinedValue) {
            //       return `Program: ${combinedValue}`;
            //     }
            //     return '';
            //   },

        },
        {
            field: 'material',
            headerName: 'Material',
            renderCell: (params) => {

                const combinedValue = params.row
                console.log(combinedValue)
                if (combinedValue) {
                    return `Material: ${combinedValue.material}`;
                }
                return '';
            },

        },

        {
            field: 'createdDate',
            headerName: 'Creation Date',
            width: 250,
            renderCell: (params) => {
                if (params.row.createdDate !== null && params.row.createdDate !== '') {
                    return params.row.createdDate;
                }
            },
            // rowSpanValueGetter: (params) => {
            //         return params.primaryId;
            //       },


            // renderCell: (params) => {
            //     const { id, api } = params;  

            //     console.log(id);
            //     console.log(api);


            //     const currentRowIndex = api.getSortedRowIds().indexOf(id);

            //     console.log(currentRowIndex);


            //     if (currentRowIndex > 0) {

            //         const previousRowId = api.getSortedRowIds()[currentRowIndex - 1];


            //         const previousRow = api.getRow(previousRowId);
            //         console.log(previousRow.program);

            //         const currentRow = api.getRow(id);
            //         console.log(currentRow.program);


            //         if (
            //             previousRow &&
            //             currentRow.program === previousRow.program &&
            //             currentRow.material === previousRow.material
            //         ) {

            //             return currentRow.createdDate;
            //         }
            //     }


            //     return params.row.createdDate;
            // }


        },
        {
            field: 'orderNo',
            headerName: 'OrderNo',
        },
        {
            field: 'customerName', headerName: 'Customer',
            renderCell: function (params) {
                return (
                    <div className={params.formattedValue.length > 30 ? "Customer" : "Nesting"}>
                        {params.formattedValue}
                    </div>
                );
            },

        },

        {
            field: 'size', headerName: 'Size',
        },
        {
            field: 'model', headerName: 'Model',
        },
        {
            field: 'quantity', headerName: 'Quantity',
        },
        {
            field: "ok",
            headerName: "OK",
        },
        {
            field: "rejection",
            headerName: "Rejection",
        },
        {
            field: 'reason', headerName: 'Reason',
        },


        {
            field: "completedate",
            headerName: " Completion  date ",
            valueFormatter: function (params) {
                const updatedDate = params.value;
                if (updatedDate) {
                    const formattedDate = new Date(updatedDate).toLocaleDateString("en-IN", {
                        timeZone: "Asia/Kolkata",
                        hour12: false
                    });
                    console.log(formattedDate)
                    return `Updated Date: ${formattedDate}`;
                }
                return '';
            },
        },
    ];


    // const [open, setOpen] = useState(false);
    // const [password, setPassword] = useState("");

    // const correctPassword = "YourPassword123"; 

    // const handleOpenDialog = () => {
    //     setOpen(true);
    // };

    // const handleCloseDialog = () => {
    //     setOpen(false);
    //     setPassword(""); 
    // };

    // const handlePasswordSubmit = () => {
    //     if (password === correctPassword) {
    //         exportToCsv();
    //         handleCloseDialog();
    //     } else {
    //         toast.error("Incorrect password. Export canceled.");
    //     }
    // };


    const exportToCsv = () => {
        const allColumns = columns;
        const visibleRows = flattenedRows;


        const csvData = [
            allColumns
                .map((col) => col.headerName).join(","),
            ...visibleRows.map((row) =>
                allColumns
                    .map((col) => {
                        let value = (row[col.field]);
                        if (col.field === "program") {
                            value = value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}\[\]\\\/]/gi, '');
                        }
                        const date = new Date(value);
                        if (col.field === "completedate" && value) {
                            const formattedDateTime = date.toLocaleString("en-IN", {
                                timeZone: "Asia/Kolkata",
                                hour12: false
                            });
                 
                            if (formattedDateTime === "Invalid Date" || value === "0000-00-00 00:00:01") {
                                return "-";
                            }
                            return `"${formattedDateTime}"`;
                        }

                        if (typeof value === "object" && value !== null) {
                            return `Program: ${value.program || ""}`;
                        }

                        return `${value || ""}`;
                    })
                    .join(",")
            ),
        ];

        const csvString = csvData.join("\n");
        const blob = new Blob([csvString], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "CNC Completed Records.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);


    function CustomToolbar({ rows, columns }) {

        const handlePrint = () => {

            const titleHTML = '<h2 style="text-align: center;">CNC Completed Records</h2>';
            const startIndex = currentPage * rowsPerPage;  
            const endIndex = startIndex + rowsPerPage;    
            const rowsToPrint = rows.slice(startIndex, endIndex);  

            console.log(`Printing rows from index ${startIndex} to ${endIndex}`, rowsToPrint); // Debugging
            const columnWidths = {
				"size": 15,
                "program":10
			};
            let tableHTML = '<table style="width:100%; border-collapse: collapse;">';
            tableHTML += '<thead><tr>';
            const headerNameMapping = {
                'Quantity': 'Qty',
                'Rejection': 'Rej',
              };
            columns.forEach((col) => {
                let headerName = headerNameMapping[col.headerName] || col.headerName;   
                const width = columnWidths[col.field] || 'auto';
				tableHTML += `<th style="border: 1px solid #ddd; width: ${width}%;">${headerName}</th>`;
            });
            tableHTML += '</tr></thead><tbody>';

            rowsToPrint.forEach((row) => {
                tableHTML += '<tr>';
                columns.forEach((col) => {
                    console.log('Row:', row);
                    console.log('Column Field:', col.field);

                    const cellValue = row[col.field];
                    console.log(cellValue)

                    tableHTML += `<td style="border: 1px solid #ddd; padding: 8px;">${cellValue}</td>`;
                });
                tableHTML += '</tr>';
            });

            tableHTML += '</tbody></table>';

            const iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = 'none';
            document.body.appendChild(iframe);

            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write('<html><head><title>Print DataGrid</title>');
            doc.write('<style>table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }</style>');
            doc.write('</head><body>');
            doc.write(titleHTML);
            doc.write(tableHTML);
            doc.write('</body></html>');
            doc.close();


            iframe.contentWindow.focus();
            iframe.contentWindow.print();

            document.body.removeChild(iframe)
        };


        return (
            <GridToolbarContainer sx={{ margintop: '5px' }}>
                <GridToolbar printOptions={{ disableToolbarButton: true }}  
					csvOptions={{ disableToolbarButton: true }}
					excelOptions={{ disableToolbarButton: true }}/>
                <Button onClick={exportToCsv}>
                    Export to CSV
                </Button>
                <Button onClick={handlePrint} startIcon={<PrintIcon />}
                >
                    Print
                </Button>
            </GridToolbarContainer>
        );
    }


    const rootStyles = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        '& .program-odd, & .createdDate-odd,': {
            backgroundColor: '#FFE1D6',
            alignItems: 'center',
        },
        '& .program-even, & .createdDate-even,': {
            backgroundColor: '#F2F2F2',
            alignItems: 'center',
        },
    };
    return (
        // <Container  style={{  width: "100%" }}>

        <Card sx={rootStyles}>
            <CardContent style={{ marginTop: '105px  '}}  >
                <Stack direction={'row'} sx={{ flexWrap: 'wrap', gap: 2 }} >
                    <Typography
                        gutterBottom
                        variant="h6"
                        component="div"

                    >
                        CNC Completed Records
                    </Typography>
                    <ModuleTools
                        pageName="endPlateBending"
                        OrderData={orderList}
                        refreshPage={(request) => refreshData(request)}
                    />
                    <div style={{ border: '1px solid grey' }}></div>
                    {accessModuleList.filter((x) => x.module_name === 'M1cncNesting')[0]
                        .access_rw === '1' && (
                            <NavLink to="/M1cncPunching" className="toolButton">
                                <KeyboardDoubleArrowLeftIcon style={{ color: '#BC1921' }} />
                                Prev Module
                            </NavLink>
                        )}
                    {accessModuleList.filter(
                        (x) => x.module_name === 'M2tubeCutting'
                    )[0].access_rw === '1' && (
                            <NavLink to="/tubecutting" className="toolButton">
                                Next Module
                                <KeyboardDoubleArrowRightIcon style={{ color: '#BC1921' }} />
                            </NavLink>
                        )}
                </Stack>

                <Box className="scroll1"  sx={{ width: "100%", marginTop: "40px" }}>
                    <ToastContainer />
                    <DataGrid
                        slots={{
                            toolbar: () => <CustomToolbar rows={flattenedRows} columns={columns} />
                        }}
                        // slots={{ toolbar: CustomToolbar }}
                        getRowClassName={(params) => {

                            if (params.indexRelativeToCurrentPage % 2 === 0) {
                                if (params.row.priority === 'true') {
                                    return 'secon-bg';
                                } else if (
                                    params.row.tcutting_status === 'true' &&
                                    params.row.finpunch_status === 'true'
                                ) {
                                    return 'partial-comp-bg';
                                } else {
                                    return 'Mui-even';
                                }
                            } else {
                                if (params.row.priority === 'true') {
                                    return 'secon-bg';
                                } else if (
                                    params.row.tcutting_status === 'true' &&
                                    params.row.finpunch_status === 'true'
                                ) {
                                    return 'partial-comp-bg';
                                } else {
                                    return 'Mui-odd';
                                }
                            }
                        }}
                        sx={{
                            "& .MuiDataGrid-root": {
                                width: "100% !important",
                              },
                            '& .MuiDataGrid-columnHeader': {
                                backgroundColor: '#943612',
                                color: 'white',
                            },
                            '.MuiDataGrid-row.Mui-odd ': {
                                backgroundColor: '#FFE1D6',
                            },
                            '.MuiDataGrid-row.Mui-even ': {
                                backgroundColor: '#F2F2F2',
                            },
                            '.MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell':
                            {
                              
                                whiteSpace: 'break-spaces',
                                padding: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                            },
                            '.MuiDataGrid-columnHeaderTitleContainer': {
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: '0.75rem',
                            },
                            '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
                                border: '.5px solid white',
                            },
                            '& .MuiInputBase-input': {
                                fontSize: '0.74rem',
                                padding: '16.5px 1px ',
                            },
                        }}

                        columnVisibilityModel={{
                            completedate: false,
                            material: false
                        }}
                        // getRowHeight={() => 'auto'}
                        columns={columns.map((data) => ({

                            ...data,
                            ...(data.field === 'program'
                                || data.field === 'createdDate'
                                ? { width: 170 }
                                : {
                                    flex: 1,
                                    rowSpanValueGetter: (value, row) => {

                                        console.log(value)
                                        console.log(row)
                                        
                                        return data.field === 'program' || data.field === 'createdDate'
                                            ? value
                                            : row
                                                ? `${row.program}-${row.createdDate}-${row.id}`
                                                : value;
                                    },
                                }),
                            ...slotColumnCommonFields,
                            // editable: true,
                        }))}
                        // getRowHeight={() => 'auto'}
                        rows={flattenedRows}
                        unstable_rowSpanning={true}
                        disableRowSelectionOnClick
                        onPaginationModelChange={(model) => {
                            console.log('Page:', model.page, 'PageSize:', model.pageSize);  
                            setCurrentPage(model.page);
                            setRowsPerPage(model.pageSize);
                          }}
                    />
                    {/* <Dialog open={open} onClose={handleCloseDialog}>
                        <DialogTitle>Enter Password</DialogTitle>
                        <DialogContent>
                            <TextField
                                type="password"
                                variant="outlined"
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoFocus
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} color="secondary">
                                Cancel
                            </Button>
                            <Button onClick={handlePasswordSubmit} color="primary" variant="contained">
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog> */}
                </Box>
            </CardContent>
        </Card>
        // </Container>
    );
}











